import React, {PropTypes} from 'react';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import authActions from '../../auth/auth_actions';
import requestAnItemActions from '../request_an_item_actions';
import DatePicker from '../../components/calendar/calendar';
import './delivery_details.less'
import MapComponent from '../../components/map_component/map_component';
import InputComponent from '../../components/input_component/input_component';
import LocationInput from '../../components/location_auto_search/location_auto_search';
import RadioButton from '../../components/radio_button/radio_button';
import validate from '../../util/validate';
import ShowError from '../../components/error/show_error';
import moment from 'moment';
import ReactTelephoneInput from 'react-telephone-input';
import {Link, browserHistory} from 'react-router';
import LoggedinFooter from '../../footer/loggedin_footer';
import "./telephone_input.less";
import $ from 'jquery';
import CONSTANTS from '../../common_constants';
import {toTitleCase,join,localTimestampToGMT,GMTTimeStampToLocal} from '../../util/common';

class DeliveryDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      requestAnItem : props.requestAnItem,
      error: null,
      ajaxInProgress:false,
      deliveryBy : false
    }
  }
  goBack = () =>{
    if(this.state.shipmentId)
      browserHistory.push('/request-an-item/request-details?shipmentId='+ this.state.shipmentId);
    else
      browserHistory.push('/request-an-item/request-details');
  }
  componentDidMount(){
    if(validate.isEmpty(this.props.requestAnItem))
        browserHistory.push('/request-an-item');
    const shipmentId = this.props.location.query.shipmentId;
    this.setState({
      shipmentId
    })
    if(this.props.requestAnItem.deliveryDate){
      this.setState({
          deliveryBy : true
      })
    }
  }
  changeHandler = (type , value) =>{
      this.setState({error:null});
      let requestAnItem = Object.assign({} , this.state.requestAnItem);

      const {userData} = this.props.authState;
      if(userData.email) amplitude.getInstance().setUserId(userData.email);
      amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.REQ_ITEM_DELIVERY_START);

      if(type == 'location')
      {
        if(value)
        {
          requestAnItem.deliveryLat = value.location.lat;
          requestAnItem.deliveryLong = value.location.lng;
          requestAnItem.deliveryLocation = value.label;
          requestAnItem.deliveryCountry = value.country;
          requestAnItem.deliveryCountryCode = value.countryCode;
          requestAnItem.deliveryCity = value.cityName;
          // requestAnItem.deliveryLandmark = value.landMark;   // this key will picked up by APT field
        }else{
          requestAnItem.deliveryLat = 0;
          requestAnItem.deliveryLong = 0;
          requestAnItem.deliveryLocation = null;
          requestAnItem.deliveryCountry = null;
          requestAnItem.deliveryCountryCode = null;
          requestAnItem.deliveryCity = null;
          // requestAnItem.deliveryLandmark = null;
        }
        this.setState({
              requestAnItem
        })
      }else if (type.substring(0,12) == "deliveryUser") {
          if(type.substring(13) == "name")
          {
              requestAnItem.deliveryUser.name = value
          }else if(type.substring(13) == "phone"){
              requestAnItem.deliveryUser.phone = value
          }else{
              requestAnItem.deliveryUser.email = value
          }
      }else if (type == 'deliveryDate') { //from date picker
        let date = value.unix()*1000;
        requestAnItem.deliveryDate = date;
        this.setState({
            requestAnItem
        })
      }else{
        requestAnItem[type] = value;
        this.setState({
            requestAnItem
        })
      }
  }
  handlePhoneNoChange = (phoneNo, selectedCountry) => {
    this.setState({error:null});
    let requestAnItem = Object.assign({} , this.state.requestAnItem);
    const phoneNumber = phoneNo.replace(/[-()+]/g,'');
    const countryCode ="+"+selectedCountry.dialCode;
    const formattedPhoneNo = phoneNumber.replace(selectedCountry.dialCode,'').replace(/\s/g,"");
    let deliveryUser = requestAnItem.deliveryUser || {};
    deliveryUser.phone = countryCode + formattedPhoneNo;
    deliveryUser.code = countryCode;
    deliveryUser.number  = formattedPhoneNo;
    this.setState({
        requestAnItem
    })
  }
  radioButtonChangeHandler = (value) =>{
    this.setState({error:null});
    let requestAnItem = Object.assign({},this.state.requestAnItem)
    if(value == "I Will"){
        requestAnItem.isIWillMeetCarrierAtDelivery = true;
        requestAnItem.deliveryUser = {}
    }else if(value == "Someone Else"){
        requestAnItem.isIWillMeetCarrierAtDelivery = false;
        requestAnItem.deliveryUser = {};
    }else if(value == "As soon as possible"){
      let deliveryDate = new Date().getTime() + ((8*24*60*60*1000) - 60000);
      //getting todays time , adding 8 days and then substracting 1 minute
       requestAnItem.deliveryDate = deliveryDate;
       this.setState({
         deliveryBy : false
       })
    }else{
      requestAnItem.deliveryDate = null;
       this.setState({
         deliveryBy : true
       })
    }
      this.setState({
            requestAnItem
        })
    }
  submit = (e) =>{
    e.preventDefault();
    this.setState({error:null});
    const self = this;
    let validationError , validationMap;
    if(this.state.requestAnItem.isIWillMeetCarrierAtDelivery && !this.state.deliveryBy)
    {
      validationError = {
          location: !validate.name(this.state.requestAnItem.deliveryLocation)
      };
      validationMap = {
          location: 'Location'
      };
    }else if (this.state.requestAnItem.isIWillMeetCarrierAtDelivery && this.state.deliveryBy) {
      validationError = {
          location: !validate.name(this.state.requestAnItem.deliveryLocation),
          deliveryDate : !moment(this.state.requestAnItem.deliveryDate).isValid()
      };
      validationMap = {
          location: 'Location',
          deliveryDate : "Delivery Date"
      };
    }else{
      validationError = {
          location: !validate.name(this.state.requestAnItem.deliveryLocation),
          name : !validate.name(this.state.requestAnItem.deliveryUser.name),
          phone : !validate.validatePhoneWithCountyCode(this.state.requestAnItem.deliveryUser.phone),
          email : !validate.email(this.state.requestAnItem.deliveryUser.email),
          deliveryDate : !moment(this.state.requestAnItem.deliveryDate).isValid()
      };
      validationMap = {
          location: 'Location',
          name : "Recipient's name",
          phone : "Phone Number",
          email : "Email",
          deliveryDate : "Delivery Date"
      };
    }
    if(this.inputValidation(validationError ,validationMap))
    {
      const {userData} = this.props.authState;
      if(userData.email) amplitude.getInstance().setUserId(userData.email);
      amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.REQ_ITEM_DELIVERY_NEXT);

      this.props.requestAnItemActions.storeReqeustDetails(this.state.requestAnItem);
      if(this.state.shipmentId)
        browserHistory.push('/request-an-item/confirm-details?shipmentId='+ this.state.shipmentId);
      else
        browserHistory.push('/request-an-item/confirm-details');
    }else{
      $("html, body").animate({scrollTop: 0}, 1000);
    }
  }
  saveAsDraft = () =>{
    let parameters = Object.assign({} , this.state.requestAnItem);
    parameters.shipmentStatus = 1;
    parameters.shipmentType = 2 ; //request an item
    parameters.deliveryDate = localTimestampToGMT(parameters.deliveryDate)
    let value = moment(parameters.deliveryDate)
    if(value.startOf('day').diff(moment().startOf('day') , 'days') == 0)   //check if selected date is today
    {
        parameters.deliveryDate = (new Date(value.unix()*1000).setHours(23,59,59,0))  //store end of the day with 1 minutes less
    }
    let API = "CREATE";
    if(this.state.shipmentId)
      API = "UPDATE"
    this.setState({ajaxInProgress: true});
    this.props.requestAnItemActions.createAshipment(parameters,API).then(() => {
        this.setState({ajaxInProgress: false});
        browserHistory.push('/dashboard/i-am-shipping');
    }, (errorRes) => {
        if(errorRes.error === CONSTANTS.sessionInvalid){
          this.setState({ajaxInProgress: false})
          this.props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }
        this.setState({ajaxInProgress: false,successMsg:""});
    })
  }
  inputValidation = (validationError ,validationMap) =>{
    this.setState({error:null});
    let errorMsg = "";
    const validationFields = [];
    Object.keys(validationError).forEach((key) => {
        if (validationError[key])
            validationFields.push(validationMap[key]);
        }
    );
    if (validationFields.length) {
        errorMsg = 'Please enter valid ' + join(validationFields, (item, idx) => {
            if (validationFields.length === 1)
                return "";
            if (idx > 0 && idx < validationFields.length - 1)
                return ", ";
            else if (idx === validationFields.length - 1)
                return " and ";
            return "";
        }) + '.';
    }
    if(errorMsg){
      this.setState({
        error : errorMsg,
        validationError : validationError
      });
      return false;
    }
    return true
  }
  render() {
    const {state} = this;
    const {requestAnItem} = this.state;
    const loader = <div className="loader-button"></div>;
    let phone = requestAnItem.deliveryUser ? requestAnItem.deliveryUser.phone : "";
    let deliveryDate;
    if(!requestAnItem.deliveryDate)
    {
        deliveryDate = '';
    }
    else {
        deliveryDate = new Date(requestAnItem.deliveryDate)
    }
    let pickupIndex = 0 , deliveryIndex = 0;

    if(!requestAnItem.isIWillMeetCarrierAtDelivery) pickupIndex = 1;
    const pickup = ["I Will" , "Someone Else"];

    if(state.deliveryBy)
      deliveryIndex = 1;
    const delivery =  [ "As soon as possible" , "Delivery by"];
    return (
      <div id="deliveryDetailsWrap">
        <div className = "wrapper delivery-details-wrap">
          <div className="back-section" onClick = {this.goBack}>
              <span className="icon-icn_back"></span>
              <span className = "back-content">Back</span>
          </div>
          <div className = "delivery-details">
            <div className ="error-section">
                {this.state.error && <ShowError errorMessage = {this.state.error} />}
            </div>
            <div className = "heading">
              Where is the package being delivered?
            </div>
            <MapComponent lat = {requestAnItem.deliveryLat} lng ={requestAnItem.deliveryLong} />
            <div className = "delivery-location-wrap">
              <div className = "sub-heading">
                Delivery Location
              </div>
              <div className ="input-details-wrap">
                <div className = "input-details">
                  <LocationInput type="text" value = {requestAnItem.deliveryLocation} title = "Location" placeholder = "Enter delivery location" for ="location" changeHandler = {this.changeHandler}/>
                </div>
                <div className = "input-details">
                  <InputComponent type="text" dollar ={false} value = {requestAnItem.deliveryLandmark} title = "APT, BLDG, Suite" placeholder = "Optional" for ="deliveryLandmark" changeHandler = {this.changeHandler}/>
                </div>
              </div>
              <div className ="meet-carrier">
                <div className="sub-heading" >
                  Who will meet the carrier at the pickup location?
                </div>
                <div className = "radio-section">
                  <RadioButton selected ={pickupIndex}defaultSelect = {true} radioButtonNameArray = {pickup} radioButtonName = "pickupBy" getValueCallback = {this.radioButtonChangeHandler}/>
                </div>
                {
                  !requestAnItem.isIWillMeetCarrierAtDelivery && <div className = "recipient-section">
                  <div className ="input-details-wrap">
                    <div className = "input-details">
                      <InputComponent type="text" dollar ={false} value = {validate.isEmpty(requestAnItem.deliveryUser)? "" :requestAnItem.deliveryUser.name} title = "Recipient's Full name" placeholder = "Full name" for ="deliveryUser.name"  changeHandler = {this.changeHandler}/>
                    </div>
                    <div className = "input-details">
                      <div className = "title">
                        Phone number
                      </div>
                      <ReactTelephoneInput
                        defaultCountry='us'
                        initialValue = {phone}
                        flagsImagePath = '../../public/images/signup/flags.png'
                        onChange = {this.handlePhoneNoChange}
                       />
                    </div>
                    <div className = "input-details">
                      <InputComponent type="text" dollar ={false} value = {validate.isEmpty(requestAnItem.deliveryUser)? "" :requestAnItem.deliveryUser.email} title = "Email Id" placeholder = "Email" for ="deliveryUser.email"  changeHandler = {this.changeHandler}/>
                    </div>
                  </div>
                  </div>
                }
              </div>
              <div className ="meet-carrier">
                <div className="sub-heading" >
                  Deliver by
                </div>
                <div className = "radio-section">
                  <RadioButton selected = {deliveryIndex} defaultSelect = {true} radioButtonNameArray = {delivery} radioButtonName = "delivery" getValueCallback = {this.radioButtonChangeHandler}/>
                </div>
                {
                  state.deliveryBy && <div className = "date-picker-section">
                  <DatePicker for = "deliveryDate" value = {deliveryDate} dateChangeHandler = {this.changeHandler}/>
                  </div>
                }
              </div>
              <div className = "additional-notes">
                <div className = "sub-heading">
                  Additional Notes
                </div>
                <div className = "additional-notes-content">
                  Add any additional details the carrier may need to know; ie: Desired pickup or delivery times, gate codes, etc.
                </div>
              </div>
              <div className ="input-details-wrap">
                <div className = "input-details">
                  <InputComponent type="text" dollar ={false} value = {requestAnItem.notes} title = "Add notes" placeholder = "Optional" for ="notes"  changeHandler = {this.changeHandler}/>
                </div>
              </div>
              <div className = "submit-section">
                <div className = "submit-options">
                    <button className = "btn orange" onClick = {this.submit} >Next</button>
                </div>
                <div className = "submit-options m-l">
                    <button className = "btn green" onClick = {this.saveAsDraft} >{this.state.ajaxInProgress? loader : 'Save and Exit'}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <LoggedinFooter/>
      </div>
    )
  }
}

DeliveryDetails = connect((state) => {
  return {
    requestAnItem : state.app.requestAnItem,
    authState: state.app.auth
  }
}, (dispatch) => {
  return {
    routerActions: bindActionCreators(routerActions, dispatch),
    authActions : bindActionCreators(authActions, dispatch),
    requestAnItemActions :bindActionCreators(requestAnItemActions, dispatch)
  }
})(DeliveryDetails);

export default DeliveryDetails;



// WEBPACK FOOTER //
// app/request_an_item/delivery_details/delivery_details.jsx